import { AccessListUser, Gender } from '@statsbomb/parachute-types';
import { SYSTEM_WIDE_USER_ID } from '@/consts/userConfigs';
import { Entity } from '@/types/entity';
import { UserConfigRadarTemplate } from '@/types/userConfigs';

// filters templates by entity type and applies gender-based filtering only to statsbomb-shared templates.
export const filterRadarTemplates = (
  radarTemplates: UserConfigRadarTemplate[],
  type: Entity,
  gender: Gender = Gender.M,
) =>
  radarTemplates.filter(
    template =>
      template.definition.entity === type &&
      (template.hudlUserId !== SYSTEM_WIDE_USER_ID ||
        (template.hudlUserId === SYSTEM_WIDE_USER_ID && template.definition.gender === gender)),
  );

export const formatRadarTemplates = (radarTemplates: UserConfigRadarTemplate[]) =>
  radarTemplates.map(template => ({
    id: template.configId,
    titleSettings: template.definition.titleSettings,
    positions: template.definition.positions,
    metrics: template.definition.metrics,
  }));

export const hasFullAccessPermissions = (permission?: AccessListUser['permission']) =>
  permission === 'own' || permission === 'full';

export const hasEditPermissions = (permission?: AccessListUser['permission']) =>
  hasFullAccessPermissions(permission) || permission === 'edit';
